import { render, staticRenderFns } from "./transactionTab.vue?vue&type=template&id=2f148ea6&"
import script from "./transactionTab.vue?vue&type=script&lang=js&"
export * from "./transactionTab.vue?vue&type=script&lang=js&"
import style0 from "./transactionTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "transactionTab.vue"
export default component.exports